import qs from 'qs';

const subscriptionConfirmPage = () => {
  const query = qs.stringify({
    populate: ['image'],
  });
  return '/subscription-confirm-page?' + query;
};

export default subscriptionConfirmPage;
